import { useTranslation } from 'react-i18next'
import { useLocation, useParams } from 'react-router'
import { Head } from '#/components/head'
import { Button } from '#/components/ui/button'
import { Separator } from '#/components/ui/separator'
import { Heading, Text } from '#/components/ui/typography'


export default function PersonalKeycardLoading() {
  const { t } = useTranslation([ 'personal_keycards' ])
  const params = useParams() as { personalKeycardId: string }
  const { state } = useLocation()

  // Display name might be available from nav state
  const personalKeycardName = state?.name ?? params.personalKeycardId

  return (
    <div className="flex grow flex-col gap-4 items-start">

      <Head title={personalKeycardName} />

      <div className="flex w-full items-end justify-between gap-4">
        <Heading>{personalKeycardName}</Heading>
        <Button className="invisible" />
      </div>

      <Separator />

      <Text>{t('view_personal_keycard.loading')}</Text>

    </div>
  )
}
